import {tailwind} from 'am-config';

const {
  theme: {
    colors,
  },
} = tailwind;

export default colors;
